import { Component, Element, Listen } from '@stencil/core';

@Component({
    tag: 'scspies-offcanvas-button'
})
export class Gallery {

    @Element() el!: HTMLElement;

    private nav!: HTMLElement;
    private html!: HTMLElement;

    componentDidLoad(): void {
        this.html = document.querySelector('html') as HTMLElement;
        this.nav = document.querySelector('#nav') as HTMLElement;

        this.updateNavHeight();
        window.addEventListener('resize', this.updateNavHeight);
    }

    disconnectedCallback(): void {
        window.removeEventListener('resize', this.updateNavHeight);
    }

    @Listen('click', { capture: true })
    handleClick() {
        this.el.classList.toggle('active');
        this.html.classList.toggle('offcanvas-visible');
        if (this.html.classList.contains('offcanvas-visible')) {
            this.onOpen();
        }
    }

    onOpen() {
        this.nav.scrollTop = 0;
        this.html.scrollTop = 0;
    }

    private updateNavHeight = () => {
        if (!this.nav) {
            return;
        }
        const headerHeight = (document.querySelector('#header') as HTMLElement).getBoundingClientRect().height;

        this.nav.style.setProperty('--window-height', `${window.innerHeight}px`);
        this.nav.style.setProperty('--header-height', `${headerHeight}px`);
    };

}
